import style from './Object.module.css';

import { PUBLIC_ASSETS, address_server_short } from 'config';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import Icon from 'ui/Icon';
import FormTextField from 'ui/formItems/FormTextField';

const DerivedObject = ({ object, index }) => {
  const { setValue } = useFormContext();

  const selectedSourceItem = useMemo(() => {
    setValue(
      `objects.[${index}].value.volume`,
      object?.value?.amount ? Number(object?.value.amount) : 0,
    );
    return object?.value;
  }, [index, object]);

  useEffect(() => {
    setValue(`objects.[${index}].id`, object.id);
    setValue(`objects.[${index}].type`, object.type);
    setValue(`objects.[${index}].derived`, object.derived);
    if (object.value !== null) {
      if (object.type === 'type_samples')
        setValue(`objects.[${index}].value.volume`, object?.value?.volume?.amount);
      setValue(`objects.[${index}].value.id`, object?.value?.id);
    }
  }, []);

  return (
    <div className={style.objectContainer}>
      <div className={style.objectIconContainer}>
        <Icon
          width="44px"
          height="44px"
          src={address_server_short + PUBLIC_ASSETS + (object?.image ?? '')}
        />
        <div>{object?.name}</div>
      </div>
      <div className={style.objectAutocomplete}>{`ID: ${object.value.id_general}`}</div>
      {object?.type !== 'type_sample_sources' && (
        <>
          <FormTextField
            name={`objects.[${index}].value.volume`}
            defaultValue={
              selectedSourceItem?.volume?.amount ? Number(selectedSourceItem.volume.amount) : 0
            }
            min={0}
            hideErrorBlock
            className={style.objectInput}
            label="Количество:"
            max={selectedSourceItem?.volume?.amount ? Number(selectedSourceItem.volume.amount) : 0}
            type={'number'}
            step={0.1}
          />
          <div className={style.objectUnit}>
            {selectedSourceItem && selectedSourceItem.volume?.unit_name}
          </div>
        </>
      )}
    </div>
  );
};

export default DerivedObject;
